// extracted by mini-css-extract-plugin
export default {"navigate":"styles_navigate__2gZHH"};